import React from 'react';

function Document() {
  return (
    <div>
      <svg
        width='81'
        height='80'
        viewBox='0 0 81 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_324)'>
          <rect x='0.5' width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M23.6809 56C22.6316 56 21.7562 55.648 21.0546 54.944C20.3531 54.24 20.0015 53.3608 20 52.3063V27.6937C20 26.6408 20.3515 25.7623 21.0546 25.0583C21.7577 24.3543 22.6324 24.0015 23.6786 24H35.0242L39.5798 28.5714H57.3214C58.3692 28.5714 59.2446 28.9242 59.9477 29.6297C60.6507 30.3352 61.0015 31.2137 61 32.2651V52.3086C61 53.36 60.6492 54.2385 59.9477 54.944C59.2461 55.6495 58.3707 56.0015 57.3214 56H23.6809ZM23.6809 53.7143H57.3214C57.7299 53.7143 58.0655 53.5825 58.3282 53.3188C58.5909 53.0552 58.7222 52.7185 58.7222 52.3086V32.2629C58.7222 31.853 58.5909 31.5162 58.3282 31.2526C58.0655 30.989 57.7299 30.8571 57.3214 30.8571H38.6664L34.1108 26.2857H23.6786C23.2701 26.2857 22.9345 26.4175 22.6718 26.6811C22.4091 26.9448 22.2778 27.2823 22.2778 27.6937V52.3086C22.2778 52.7185 22.4091 53.0552 22.6718 53.3188C22.9345 53.5825 23.2709 53.7143 23.6809 53.7143Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_324'
            x='-3.92632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_324'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Document;
